var $30778544d96b2ef3$exports = {};
$30778544d96b2ef3$exports = {
    "actions": `Handlinger`,
    "hideButtonLabel": `Vis mindre`,
    "noTags": `Ingen`,
    "showAllButtonLabel": (args, formatter)=>`Vis alle (${formatter.number(args.tagCount)})`
};


export {$30778544d96b2ef3$exports as default};
//# sourceMappingURL=da-DK.mjs.map
